import { Box, Typography } from "@mui/material";

import { CustomSingleSelect } from "../common/inputFields/customSingleSelect";

/** `months_back` API values exposed as the Date Filter dropdown. */
export const DATE_FILTER_MONTHS = [12, 24, 36, 48] as const;
export const DATE_FILTER_MONTH_SET = new Set<number>(DATE_FILTER_MONTHS);

export const DATE_FILTER_SELECT_OPTIONS = DATE_FILTER_MONTHS.map((n) => ({
  id: String(n),
  label: `Last ${n} months`,
}));

const FILTER_FIELD_ERROR_COLOR = "#BA2C2C";

const fieldErrorSx = {
  color: `${FILTER_FIELD_ERROR_COLOR} !important`,
  fontSize: "0.65rem",
  lineHeight: 1.25,
  mt: 0.25,
  display: "block",
} as const;

export interface DealCompDateFilterProps {
  value: string;
  onChange: (next: string) => void;
  /** When true, label and control spacing align with dense `CustomTextInput` filter fields. */
  matchFilterFieldStyle: boolean;
  /** Invalid selection (e.g. value outside allowed months). */
  invalid?: boolean;
  label?: string;
  placeholder?: string;
  errorMessage?: string | null;
}

export function DealCompDateFilter({
  value,
  onChange,
  matchFilterFieldStyle,
  invalid = false,
  placeholder = "Select Time Range",
  errorMessage = null,
}: DealCompDateFilterProps) {
  const select = (
    <CustomSingleSelect
      value={value === "" ? "" : value}
      onChange={(e) =>
        onChange(e.target.value === "" ? "" : String(e.target.value))
      }
      options={DATE_FILTER_SELECT_OPTIONS}
      labelKey="label"
      placeholder={placeholder}
      fullWidth
      redOutline={invalid}
      heightOverride="32px"
      fontSizeOverride="12px"
    />
  );

  if (!matchFilterFieldStyle) {
    return (
      <Box
        sx={{ display: "flex", flexDirection: "column", alignItems: "stretch" }}
      >
        {select}
        {errorMessage ? (
          <Typography component="span" sx={fieldErrorSx}>
            Input must be: {errorMessage}
          </Typography>
        ) : null}
      </Box>
    );
  }

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", alignItems: "stretch" }}
    >
      <Box
        sx={{
          mt: 0,
          /* Dense TextField (margin dense) sits ~4px below shrunk label; align select block. */
          "& .custom-select": {
            fontFamily: "Helvetica Neue, sans-serif !important",
          },
        }}
      >
        {select}
      </Box>
      {errorMessage ? (
        <Typography component="span" sx={fieldErrorSx}>
          Input must be: {errorMessage}
        </Typography>
      ) : null}
    </Box>
  );
}
